import { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images, index, onClose, onPrev, onNext }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose, onPrev, onNext]);

  if (index == null) return null;
  return (
    <div className="lightbox" onClick={onClose} data-testid="lightbox">
      <button className="lb-close" onClick={onClose} data-testid="lb-close" aria-label="Close">
        <X size={20} />
      </button>
      {images.length > 1 && (
        <>
          <button className="lb-prev" onClick={(e) => { e.stopPropagation(); onPrev(); }} data-testid="lb-prev" aria-label="Previous">
            <ChevronLeft size={20} />
          </button>
          <button className="lb-next" onClick={(e) => { e.stopPropagation(); onNext(); }} data-testid="lb-next" aria-label="Next">
            <ChevronRight size={20} />
          </button>
        </>
      )}
      <img src={images[index]} alt="Project" onClick={(e) => e.stopPropagation()} />
    </div>
  );
}
